import { trackPWAEvent } from '@/lib/analytics';

export const registerPWA = () => {
  if (!import.meta.env.PROD) {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().catch(() => {
            // Ignore unregister failures in development
          });
        });
      });

      if ('caches' in window) {
        caches.keys().then((keys) => {
          keys.forEach((key) => {
            caches.delete(key).catch(() => {
              // Ignore cache cleanup failures in development
            });
          });
        });
      }
    }

    return;
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').then(() => {
      trackPWAEvent('sw_registered');
    }).catch(() => {
      // Service worker registration failed silently
    });
  }
};
